import { createUserPermissionsPlain } from '@sonifi/wb-user/services/permissions.service';

const formatProperties = (user) => {
  if (user.all_groups) {
    return 'All Properties';
  } else if (!user.groups || !user.groups.length) {
    return '-';
  } else {
    return user.groups
      .reduce((value, group) => {
        if (group.cms_id) {
          value = `${value}${group.cms_id}, ${group.name} (${group.city}, ${group.state}); `;
          return value;
        }
        return value;
      }, '')
      .slice(0, -2);
  }
};

export const getUsersMapped = ({ groups, permissions, users }) => {
  const usersMapped = users.map((user) => {
    const userGroups = groups.reduce((acc, g) => {
      const groupFound = user.groups.some((ug) => ug === g.uri);
      if (groupFound) {
        acc.push(g);
      }
      return acc;
    }, []);

    const permissionsList = createUserPermissionsPlain({ permissions, user });
    user.permissionsList = permissionsList;

    const auxUser = {
      ...user,
      groups: userGroups,
    };

    const fullName = `${user.last_name ? `${user.last_name}` : ''}${
      user.first_name ? `, ${user.first_name}` : ''
    }`;

    return {
      ...auxUser,
      fullName,
      propertyAssigments: formatProperties(auxUser),
    };
  });
  return usersMapped;
};

// The API returns this generic unique-constraint code for any model.
const DUPLICATE_ENTRY_CODE = 23;

export const USER_EXISTS_ERROR_MESSAGE =
  'This email is already in the system. For help re-enabling users, call our technical support team at 1-888-563-4363.';

// On create, a duplicate email can belong to a user the admin no longer has
// access to manage (e.g. removed from all of their sites), so they cannot
// find or re-enable that user themselves.
export const mapCreateUserErrors = (errors) =>
  Array.isArray(errors)
    ? errors.map((e) =>
        e.code === DUPLICATE_ENTRY_CODE && e.field === 'email'
          ? { ...e, error: USER_EXISTS_ERROR_MESSAGE }
          : e,
      )
    : errors;
